import { render, staticRenderFns } from "./medium_select.vue?vue&type=template&id=853fe326&lang=pug"
import script from "./medium_select.vue?vue&type=script&lang=js"
export * from "./medium_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports